// TermSheetQRCode — SVG QR code embedding the public verification URL (/verify/<digest>), with one-click PNG export for PDFs and investor decks.
import React, { useRef } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Download, Copy, QrCode } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "@/context/LangContext";
import { vtx } from "@/lib/verifyI18n";

export const TermSheetQRCode = ({ url, size = 148, label, fileName = "term-sheet-verify-qr" }) => {
  const box = useRef(null); const { lang } = useLang(); const t = vtx(lang); label = label || t.qr_label;
  const exportPng = () => {
    const svg = box.current?.querySelector("svg"); if (!svg) return;
    const xml = new XMLSerializer().serializeToString(svg); const img = new Image(); const scale = 4;
    img.onload = () => {
      const c = document.createElement("canvas"); c.width = size * scale; c.height = size * scale; const ctx = c.getContext("2d");
      ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, c.width, c.height); ctx.drawImage(img, 0, 0, c.width, c.height);
      c.toBlob((blob) => { const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = `${fileName}.png`; a.click(); URL.revokeObjectURL(a.href); toast.success(t.qr_exported); }, "image/png");
    };
    img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(xml);
  };
  return (
    <div className="inline-flex flex-col items-center gap-2" data-testid="ts-qr">
      <div ref={box} className="bg-white p-2" data-testid="ts-qr-svg"><QRCodeSVG value={url} size={size} level="M" marginSize={0} /></div>
      <p className="text-[10px] uppercase tracking-widest text-slate-500 flex items-center gap-1"><QrCode className="h-3 w-3" /> {label}</p>
      <div className="flex gap-1 text-[10px]">
        <button data-testid="ts-qr-png" onClick={exportPng} className="border border-white/15 px-2 py-1 inline-flex items-center gap-1 hover:border-[#00FFFF]/50"><Download className="h-3 w-3" /> {t.qr_png}</button>
        <button data-testid="ts-qr-copy" onClick={() => { navigator.clipboard?.writeText(url); toast.success(t.qr_copied); }} className="border border-white/15 px-2 py-1 inline-flex items-center gap-1 hover:border-[#00FFFF]/50"><Copy className="h-3 w-3" /> {t.qr_url}</button>
      </div>
    </div>
  );
};
